import React from 'react';
import {
  FDBox,
  FDPaper, FDTitleText,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { RoadmapGoalItem } from './RoadmapGoalItem';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .done();

export const RoadmapGoals = ({
  goals, showProgress = false,
}) => {
  const theme = useTheme();
  if (goals.length === 0) {
    return null;
  }
  return (
    <FDPaper>
      {goals.map(((goal, i) => (
        <FDBox key={goal.id()}>
          <MetaResourceRenderer
            key={goal.id()}
            resource={goal}
            metaOverrideSet={metaOverrideSet}
            layout={RoadmapGoalItem}
            LayoutProps={{
              showProgress,
            }}
          />
          {i !== (goals.length - 1)
            ? <hr style={{
              border: 'none',
              backgroundColor: `${theme.palette.facet.stone600}`,
              margin: '0px',
              height: '1px',
              width: '100%',
            }}
            /> : null }
        </FDBox>
      )))}
    </FDPaper>
  );
};
